import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguageStore } from '../../state/useLanguageStore';

interface LanguageSwitcherProps {
  className?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className = '',
}) => {
  const { language, toggleLanguage } = useLanguageStore();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 transition-colors ${className}`}
      title={
        language === 'fr' ? 'Passer en arabe' : 'التبديل إلى الفرنسية'
      }
    >
      <Globe className="h-4 w-4 flex-shrink-0" />
      <span className="text-sm font-medium">
        {language === 'fr' ? 'عربي' : 'FR'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
